import { useRegisterSW } from 'virtual:pwa-register/react';

import { PwaUpdateBanner as UiPwaUpdateBanner } from '@kilat/ui';

import { logger } from '../lib/logger.js';
import { useI18n } from '../lib/use-i18n.js';

/**
 * Agent-pwa thin wrapper around the shared `<PwaUpdateBanner>`.
 * Owns the mid-pitch-aware copy so an agent in front of a prospect
 * isn't surprised mid-demo.
 */
export function PwaUpdateBanner() {
  const t = useI18n();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      logger.info('agent pwa: service worker registered', { hasReg: Boolean(r) });
    },
    onRegisterError(error) {
      logger.warn('agent pwa: service worker register failed', { error: String(error) });
    },
  });

  return (
    <UiPwaUpdateBanner
      needRefresh={needRefresh}
      onApply={() => void updateServiceWorker(true)}
      onDismiss={() => setNeedRefresh(false)}
      headline={t.t('agent.pwaUpdate.headline')}
      body={t.t('agent.pwaUpdate.body')}
      primaryLabel={t.t('agent.pwaUpdate.reload')}
      secondaryLabel={t.t('agent.pwaUpdate.notYet')}
      placement="bottom-center"
    />
  );
}
